import React, {useState} from 'react';
import {useStores} from "../../stores/Context";
import {v4 as uuidv4} from "uuid";
import styles from "./CreateForm.module.scss";
import {BackCreateWidgetHome, TitreConfigurerPhidget, WidgetTitre} from "./FormConfiguration";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus, faRssSquare, faTimes} from "@fortawesome/free-solid-svg-icons";
import {Button, Modal} from "react-bootstrap";
import {observer} from "mobx-react";
import CreateRSSExample from "./CreateRSSExample";
import BtnAction from "../../boiteAOutils/BtnAction";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import BtnSvg from "../../boiteAOutils/BtnSvg";

const CreateRSS = observer(() => {
    const {widgetStore, uiStore} = useStores();
    const [formAdd, setFromAdd] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState(false);

    const listRss = widgetStore.listRSSDispo;

    const getData = (name, url, img) => {
        widgetStore.addWidgetAvailable({
            idWidget: uuidv4(),
            typeWidget: 'WidgetRss',
            nomWidget: name,
            config: {
                rss_url_adress: url
                , rss_img_adress: img
            }
        });
        uiStore.backNivOAfterAddPhidget();
    }

    const handleChoice = (flux) => {
        let name = flux.rss_name;
        let url = flux.rss_URL;
        let img = flux.rss_img;
        getData(name, url, img);
    }

    const handleAddRSS = () => {
        setFromAdd(true);
    }

    const handleCancelAdd = () => {
        setFromAdd(false);
    }

    const modalRemoveWidget = (flux) => {
        setModalData(flux)
        setModalShow(true)
    }

    const MyVerticallyCenteredModal = (props) => {
        let data = props.data
        return (
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <h4>Effacer le flux RSS : <i>{data.rss_name}</i> ?</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className={"w-75 mx-auto"}>
                        <div className={`row ${styles.fluxRss}`}>
                            <div className="col-4 border p-3">
                                {data.rss_img ? (
                                    <img src={data.rss_img} className={"mx-auto"} alt="Logo flux rss"
                                         style={{maxHeight: "3em", maxWidth: "100%"}}/>
                                ) : (
                                    <FontAwesomeIcon icon={faRssSquare} className={"fa-4x"} style={{color: "#e67e22"}}/>
                                )}
                            </div>
                            <div className="col-8 border p-3">
                                <h5>{data.rss_name}</h5>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className={'buttonsOption'}>
                    <Button onClick={() => removeFluxRss(data.id)}>Oui</Button>
                    <Button variant="danger" onClick={props.onHide}>Non</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    const removeFluxRss = (id) => {
        widgetStore.removeFluxRss(id).then(() => setModalShow(false));
    }

    return (
        <>
            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Flux RSS"}/>
            </div>

            <div>
                {!formAdd ? (
                    <div>
                        <h3 className={"text-center"}>Liste des flux RSS disponibles</h3>

                        <div className={`${styles.listeFluxRss}`}>
                            {listRss.map((flux) => {
                                return (
                                    <div className={`${styles.fluxRss}`}>
                                        {flux.rss_name}<br/>
                                        <BtnPrimary onClick={() => handleChoice(flux)}
                                                    children={"Ajouter ce flux à mon phidget"}/>
                                        {flux.rss_id_totem && (
                                            <BtnSvg svg={"corbeille"} onClick={() => modalRemoveWidget(flux)}
                                                    style={{position: "absolute", top: "10px", right: "10px"}}/>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                        <BtnAction onClick={handleAddRSS}>+ Ajouter un flux RSS</BtnAction>
                    </div>
                ) : (
                    <CreateRSSExample handleCancelAdd={handleCancelAdd}/>
                )}
            </div>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                data={modalData}
            />
        </>
    );
});

export default CreateRSS;